import { render, staticRenderFns } from "./ModalNewRoomControl.vue?vue&type=template&id=92c0c6ac&"
import script from "./ModalNewRoomControl.vue?vue&type=script&lang=js&"
export * from "./ModalNewRoomControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports